<div class="multi-select">
  <div class="dropdown-header" (click)="toggleDropdown($event)">
    @if (selected.size > 0 ){<span>{{ selectedLabel }}</span>}
    @if (selected.size == 0) {<span>{{ label }}</span>}
    <span class="material-symbols-outlined">{{ dropdownOpen ? 'arrow_drop_up' : 'arrow_drop_down' }}</span>
  </div>

  @if (dropdownOpen) {
  <div class="dropdown-options">
    @for (option of options; track option) {
    <label>
      <input type="checkbox" [checked]="selected.has(option.key)" (change)="selectOption(option, $event)">
      {{ option.label }}
    </label>
    }
  </div>
  }
</div>
